module.exports = __webpack_public_path__ + "static/img/icon-noti.767cb641.svg";